module.exports = __webpack_public_path__ + "static/img/news3.cc4e540e.png";